import { GmailIcon } from "Icons/Gmail";
import { OutlookIcon } from "Icons/Outlook";

import { css } from "@emotion/react";

import Image from "next/image";
import Link from "next/link";

import { Divider } from "components/shared/library/Divider";
import { Typography } from "components/shared/library/Typography";

import { getGmailUrl, getICloudMailUrl, getOutlookUrl } from "utils/urls";

import { uiGray } from "constants/colors";

const style = {
  wrapper: css({
    padding: "0px 24px 0px 24px",
  }),
  link: css({
    display: "flex",
    gap: 8,
    alignItems: "center",
    textDecoration: "none",
  }),
  divider: css({
    margin: "16px 0",
  }),
};

export const MailBoxLinks = () => {
  return (
    <div css={style.wrapper}>
      <Link href={getGmailUrl()} css={style.link} target="_blank">
        <GmailIcon height={32} width={32} />
        <Typography color={uiGray[100]} weight="bold">
          Open Gmail
        </Typography>
      </Link>
      <Divider customCss={style.divider} />
      <Link href={getOutlookUrl()} css={style.link} target="_blank">
        <OutlookIcon height={32} width={32} />
        <Typography color={uiGray[100]} weight="bold">
          Open Outlook
        </Typography>
      </Link>
      <Divider customCss={style.divider} />
      <Link href={getICloudMailUrl()} css={style.link} target="_blank">
        <Image
          src={"/images/outlook.png"}
          alt={"Outlook"}
          width={32}
          height={32}
        />
        <Typography color={uiGray[100]} weight="bold">
          Open iCloud
        </Typography>
      </Link>
    </div>
  );
};
